var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('button',{attrs:{"id":"startBtn"}},[_vm._v(" 开始 ")]),_c('button',{attrs:{"id":"endBtn"}},[_vm._v(" 结束 ")]),_c('div',{attrs:{"id":"output"}}),_c('div',{attrs:{"id":"time"}},[_vm._v("00: 00")])])
}]

export { render, staticRenderFns }